'use strict';

export const CourseStatus = {
	All: 'All courses',
	NotStarted: 'Not started',
	InProgress: 'In progress',
	Completed: 'Completed',
};

export const buildCourseStatusFilter = (status) => {
	const { completed_ids, in_progress_ids } = getUserCourses();
	
	const toObjectId = (id) => `objectID:"${ id }"`;
	
	switch (status) {
		case CourseStatus.Completed:
			return completed_ids.length ? completed_ids.map(toObjectId).join(' OR ') : toObjectId('__EMPTY__');
		case CourseStatus.InProgress:
			return in_progress_ids.length ? in_progress_ids.map(toObjectId).join(' OR ') : toObjectId('__EMPTY__');
		case CourseStatus.NotStarted:
			const started = [...completed_ids, ...in_progress_ids];
			return started.length ? started.map(id => `NOT ${ toObjectId(id) }`).join(' AND ') : null;
		default:
			return null;
	}
};

export const getUserCourses = () => {
	const education = window.InterNACHI?.shared?.education ?? {};
	
	return {
		completed_ids: education.completed_object_ids ?? [],
		in_progress_ids: education.in_progress_object_ids ?? [],
	};
};

export const courseStatusFor = (object_id) => {
	const { completed_ids, in_progress_ids } = getUserCourses();
	
	if (completed_ids.includes(object_id)) {
		return CourseStatus.Completed;
	}
	
	if (in_progress_ids.includes(object_id)) {
		return CourseStatus.InProgress;
	}
	
	return null;
};
